module.exports = __webpack_public_path__ + "static/media/gem5.51876b7f.png";